import store from '@/store'
import { getAccessToken } from '@/utils/accessToken'

const DEFAULT_REASON = ''
const PHONE_LOGIN_ENABLED = process.env.VUE_APP_ENABLE_PHONE_LOGIN === 'true'
const PASSWORD_LOGIN_ENABLED = process.env.VUE_APP_ENABLE_PASSWORD_LOGIN === 'true'
const DEFAULT_LOGIN_TAB = PHONE_LOGIN_ENABLED ? 'phone' : 'email'

const REASON_I18N_KEYS = {
  auth_required: 'views.login.reason_auth_required',
  chat: 'views.login.reason_chat',
  knowledge: 'views.login.reason_knowledge',
  assets: 'views.login.reason_assets',
  account: 'views.login.reason_account',
  subscription: 'views.login.reason_subscription',
  invite: 'views.login.reason_invite',
  image_recents: 'views.login.reason_image_recents',
  upload: 'views.login.reason_upload',
  image_generation: 'views.login.reason_image_generation',
  web_generation: 'views.login.reason_web_generation',
  payment_result: 'views.login.reason_payment_result'
}

function normalizeRedirect(redirect) {
  if (typeof redirect !== 'string') return ''

  const normalized = redirect.trim()
  if (!normalized.startsWith('/') || normalized.startsWith('//')) return ''
  if (normalized === '/login' || normalized.startsWith('/login?')) return '/home'

  return normalized
}

function normalizeInviteCode(inviteCode) {
  return typeof inviteCode === 'string' ? inviteCode.trim() : ''
}

function normalizeInitialTab(initialTab) {
  if (initialTab === 'phone' && PHONE_LOGIN_ENABLED) return 'phone'
  if (initialTab === 'email') return 'email'
  if (initialTab === 'password' && PASSWORD_LOGIN_ENABLED) return 'password'
  return DEFAULT_LOGIN_TAB
}

function normalizeReason(reason) {
  if (typeof reason !== 'string' || !reason.trim()) return DEFAULT_REASON
  const normalized = reason.trim()
  if (normalized.startsWith('views.login.') || normalized.startsWith('common.')) {
    return normalized
  }
  return REASON_I18N_KEYS[normalized] || 'views.login.reason_auth_required'
}

export function isAuthenticated() {
  return Boolean(getAccessToken())
}

export function openLoginDialog(options = {}) {
  const payload = {
    reason: normalizeReason(options.reason),
    redirect: normalizeRedirect(options.redirect),
    initialTab: normalizeInitialTab(options.initialTab)
  }
  if (Object.prototype.hasOwnProperty.call(options, 'inviteCode')) {
    payload.inviteCode = normalizeInviteCode(options.inviteCode)
  }

  return store.dispatch('authDialog/open', payload)
}

export function requireAuth(options = {}) {
  if (isAuthenticated()) return true

  openLoginDialog(options)
  return false
}
